import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import isValidTokenGroup from './isValidTokenGroup';

const RequireGroup = ({ children }) => {
    return isValidTokenGroup() ? (
        children
    ) : (
        <Navigate to="/dashboard/abstract-list" replace />
    );
};

RequireGroup.propTypes = {
    children: PropTypes.any,
};

export default RequireGroup;
